(function () {
  'use strict';

  var ATTRIBUTION_STORAGE_KEY = 'kufucat_attribution_v1';
  var NAVIGATION_EVENT_STORAGE_KEY = 'kufucat_navigation_event_v1';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var SHOPIFY_EVENT_NAMES = {
    kc_cta_click: 'kufucat:cta_click',
    kc_demo_play: 'kufucat:demo_play',
    kc_transcript_open: 'kufucat:transcript_open',
    kc_faq_open: 'kufucat:faq_open',
    kc_early_access_submit: 'kufucat:early_access_submit',
    kc_early_access_success: 'kufucat:early_access_success',
    kc_early_access_error: 'kufucat:early_access_error',
    kc_contact_submit: 'kufucat:contact_submit',
    kc_contact_success: 'kufucat:contact_success',
    kc_social_click: 'kufucat:social_click'
  };
  var pendingShopifyEvents = [];

  function cleanText(value, limit) {
    return String(value || '')
      .replace(/[\r\n\t]+/g, ' ')
      .trim()
      .slice(0, limit || 160);
  }

  function cleanDestination(value) {
    if (!value) return '';

    try {
      var destination = new URL(value, window.location.href);
      return destination.origin === window.location.origin
        ? destination.pathname
        : destination.hostname;
    } catch (error) {
      return '';
    }
  }

  function getAttribution() {
    var attribution = {};
    var params = new URLSearchParams(window.location.search);
    var hasCurrentUtm = false;

    UTM_KEYS.forEach(function (key) {
      var value = cleanText(params.get(key), 100);
      if (!value) return;
      attribution[key] = value;
      hasCurrentUtm = true;
    });

    if (hasCurrentUtm) {
      attribution.landing_path = cleanText(window.location.pathname, 160);
      try {
        window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
      } catch (error) {
        // Analytics must never block the storefront when storage is unavailable.
      }
      return attribution;
    }

    try {
      var stored = JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || '{}');
      if (!stored || typeof stored !== 'object') return attribution;

      UTM_KEYS.concat('landing_path').forEach(function (key) {
        if (stored[key]) attribution[key] = cleanText(stored[key], 160);
      });
    } catch (error) {
      // Ignore malformed or unavailable session storage.
    }

    return attribution;
  }

  function buildShopifyPayload(detail) {
    detail = detail || {};
    return Object.assign(
      {
        event_version: '1.0',
        page_path: cleanText(window.location.pathname, 160),
        section_id: cleanText(detail.section_id, 100),
        placement: cleanText(detail.placement, 100),
        label: cleanText(detail.label, 160),
        destination: cleanDestination(detail.destination),
        question: cleanText(detail.question, 200),
        video_title: cleanText(detail.video_title, 160)
      },
      getAttribution()
    );
  }

  function flushShopifyEvents() {
    if (
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== 'function'
    ) {
      return;
    }

    pendingShopifyEvents.splice(0).forEach(function (event) {
      try {
        var publication = window.Shopify.analytics.publish(event.name, event.payload);
        if (publication && typeof publication.catch === 'function') {
          publication.catch(function () {});
        }
      } catch (error) {
        // Connected pixels are optional; publishing failures must not affect UX.
      }
    });
  }

  function publishToShopify(name, detail) {
    var shopifyName = SHOPIFY_EVENT_NAMES[name];
    if (!shopifyName) return;

    pendingShopifyEvents.push({
      name: shopifyName,
      payload: buildShopifyPayload(detail)
    });
    if (pendingShopifyEvents.length > 50) pendingShopifyEvents.shift();
    flushShopifyEvents();
  }

  function deferShopifyEventUntilNextPage(name, detail) {
    var shopifyName = SHOPIFY_EVENT_NAMES[name];
    if (!shopifyName) return;

    try {
      window.sessionStorage.setItem(
        NAVIGATION_EVENT_STORAGE_KEY,
        JSON.stringify({
          name: shopifyName,
          payload: buildShopifyPayload(detail)
        })
      );
    } catch (error) {
      // If storage is unavailable, fall back to publishing on the current page.
      publishToShopify(name, detail);
    }
  }

  function restoreDeferredNavigationEvent() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(NAVIGATION_EVENT_STORAGE_KEY) || 'null');
      window.sessionStorage.removeItem(NAVIGATION_EVENT_STORAGE_KEY);
      if (!stored || !stored.name || !stored.payload) return;
      pendingShopifyEvents.push(stored);
    } catch (error) {
      // Ignore malformed or unavailable session storage.
    }
  }

  function emit(name, detail, options) {
    document.dispatchEvent(
      new CustomEvent('kufucat:event', {
        detail: Object.assign({ event: name }, detail || {})
      })
    );
    if (options && options.deferUntilNextPage) {
      deferShopifyEventUntilNextPage(name, detail);
    } else {
      publishToShopify(name, detail);
    }
  }

  function isSameOriginPageNavigation(element, event) {
    if (!element.matches('a[href]')) return false;
    if (event && (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      return false;
    }
    if (element.getAttribute('target') && element.getAttribute('target') !== '_self') return false;

    try {
      var destination = new URL(element.getAttribute('href'), window.location.href);
      if (destination.origin !== window.location.origin) return false;
      return (
        destination.pathname !== window.location.pathname ||
        destination.search !== window.location.search
      );
    } catch (error) {
      return false;
    }
  }

  function socialPlatform(link) {
    var host = cleanDestination(link.getAttribute('href'));
    if (host.indexOf('facebook') !== -1) return 'facebook';
    if (host.indexOf('instagram') !== -1) return 'instagram';
    if (host.indexOf('tiktok') !== -1) return 'tiktok';
    if (host.indexOf('youtube') !== -1 || host.indexOf('youtu.be') !== -1) return 'youtube';
    if (host.indexOf('pinterest') !== -1) return 'pinterest';
    if (host.indexOf('snapchat') !== -1) return 'snapchat';
    if (host.indexOf('tumblr') !== -1) return 'tumblr';
    if (host.indexOf('vimeo') !== -1) return 'vimeo';
    if (host.indexOf('twitter') !== -1 || host.indexOf('x.com') !== -1) return 'x';
    return 'social';
  }

  function prepareStandardEvents(root) {
    root.querySelectorAll('.list-social__link').forEach(function (link) {
      if (!link.hasAttribute('data-kc-event')) link.setAttribute('data-kc-event', 'kc_social_click');
      if (!link.hasAttribute('data-label')) link.setAttribute('data-label', socialPlatform(link));
      if (!link.hasAttribute('target')) link.setAttribute('target', '_blank');
      if (!link.hasAttribute('rel')) link.setAttribute('rel', 'noopener noreferrer');
      if (!link.hasAttribute('data-placement')) {
        link.setAttribute(
          'data-placement',
          link.closest('.menu-drawer') ? 'mobile_menu' : link.closest('.footer') ? 'footer' : 'utility'
        );
      }
    });

    root.querySelectorAll('#ContactForm').forEach(function (form) {
      if (form.hasAttribute('data-kc-contact-form')) return;
      form.setAttribute('data-kc-contact-form', '');
    });
  }

  function activateResponsivePosters(root) {
    root.querySelectorAll('[data-kc-video]').forEach(function (video) {
      var desktop = video.getAttribute('data-poster-desktop');
      var mobile = video.getAttribute('data-poster-mobile');
      var mobileQuery = window.matchMedia('(max-width: 749px)');

      function applyPoster() {
        var next = mobileQuery.matches && mobile ? mobile : desktop;
        if (next && video.getAttribute('poster') !== next) {
          video.setAttribute('poster', next);
        }
      }

      applyPoster();
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', applyPoster);
      }

      video.addEventListener(
        'play',
        function () {
          emit('kc_demo_play', {
            section_id: video.getAttribute('data-section-id') || '',
            video_title: video.getAttribute('aria-label') || ''
          });
        },
        { once: true }
      );
    });
  }

  function bindEvents(root) {
    root.querySelectorAll('[data-kc-event]').forEach(function (element) {
      if (element.dataset.kcBound === 'true') return;
      element.dataset.kcBound = 'true';

      var eventType = element.matches('details') ? 'toggle' : 'click';
      element.addEventListener(eventType, function (event) {
        if (element.matches('details') && !element.open) return;

        emit(element.getAttribute('data-kc-event'), {
          section_id: element.getAttribute('data-section-id') || '',
          placement: element.getAttribute('data-placement') || '',
          label: element.getAttribute('data-label') || '',
          destination: element.getAttribute('href') || '',
          question: element.getAttribute('data-question') || ''
        }, {
          deferUntilNextPage: eventType === 'click' && isSameOriginPageNavigation(element, event)
        });
      });
    });

    root.querySelectorAll('[data-kc-early-access-form]').forEach(function (form) {
      if (form.dataset.kcBound === 'true') return;
      form.dataset.kcBound = 'true';
      form.addEventListener('submit', function () {
        emit('kc_early_access_submit', {
          section_id: form.getAttribute('data-section-id') || ''
        });
      });
    });

    root.querySelectorAll('[data-kc-contact-form]').forEach(function (form) {
      if (form.dataset.kcContactBound === 'true') return;
      form.dataset.kcContactBound = 'true';
      form.addEventListener('submit', function () {
        emit('kc_contact_submit', { placement: 'contact_page' });
      });
    });
  }

  function reportFormResults(root) {
    root.querySelectorAll('[data-kc-form-result]').forEach(function (result) {
      if (result.dataset.kcReported === 'true') return;
      result.dataset.kcReported = 'true';
      emit(
        result.getAttribute('data-kc-form-result') === 'success'
          ? 'kc_early_access_success'
          : 'kc_early_access_error',
        { section_id: result.getAttribute('data-section-id') || '' }
      );
      result.focus();
    });

    if (
      root === document &&
      window.location.pathname.indexOf('/pages/contact') !== -1 &&
      new URLSearchParams(window.location.search).get('contact_posted') === 'true' &&
      document.documentElement.dataset.kcContactSuccessReported !== 'true'
    ) {
      document.documentElement.dataset.kcContactSuccessReported = 'true';
      emit('kc_contact_success', { placement: 'contact_page' });
    }
  }

  function init(root) {
    prepareStandardEvents(root);
    activateResponsivePosters(root);
    bindEvents(root);
    reportFormResults(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    restoreDeferredNavigationEvent();
    init(document);
    [250, 1000, 3000].forEach(function (delay) {
      window.setTimeout(flushShopifyEvents, delay);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
